var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},_vm._l((_vm.components),function({ __component, ...props },index){return _c('DynamicComponent',_vm._b({key:`${__component}-${index}`,attrs:{"type":__component,"locale":_vm.locale}},'DynamicComponent',props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }